import { BeautyIcon, ElectronicsIcon, FashionIcon, FoodIcon, HealthIcon, HomeIcon } from "../../assets/icon";
import { Briefcase, GraduationCap, Car, Dumbbell, Plane, Landmark, MoreHorizontal } from "lucide-react";

export const nigeriaStates = [
  { value: "Abia", label: "Abia" },
  { value: "Adamawa", label: "Adamawa" },
  { value: "Akwa Ibom", label: "Akwa Ibom" },
  { value: "Anambra", label: "Anambra" },
  { value: "Bauchi", label: "Bauchi" },
  { value: "Bayelsa", label: "Bayelsa" },
  { value: "Benue", label: "Benue" },
  { value: "Borno", label: "Borno" },
  { value: "Cross River", label: "Cross River" },
  { value: "Delta", label: "Delta" },
  { value: "Ebonyi", label: "Ebonyi" },
  { value: "Edo", label: "Edo" },
  { value: "Ekiti", label: "Ekiti" },
  { value: "Enugu", label: "Enugu" },
  { value: "Gombe", label: "Gombe" },
  { value: "Imo", label: "Imo" },
  { value: "Jigawa", label: "Jigawa" },
  { value: "Kaduna", label: "Kaduna" },
  { value: "Kano", label: "Kano" },
  { value: "Katsina", label: "Katsina" },
  { value: "Kebbi", label: "Kebbi" },
  { value: "Kogi", label: "Kogi" },
  { value: "Kwara", label: "Kwara" },
  { value: "Lagos", label: "Lagos" },
  { value: "Nasarawa", label: "Nasarawa" },
  { value: "Niger", label: "Niger" },
  { value: "Ogun", label: "Ogun" },
  { value: "Ondo", label: "Ondo" },
  { value: "Osun", label: "Osun" },
  { value: "Oyo", label: "Oyo" },
  { value: "Plateau", label: "Plateau" },
  { value: "Rivers", label: "Rivers" },
  { value: "Sokoto", label: "Sokoto" },
  { value: "Taraba", label: "Taraba" },
  { value: "Yobe", label: "Yobe" },
  { value: "Zamfara", label: "Zamfara" },
  { value: "FCT", label: "FCT (Abuja)" },
  { value: "Outside", label: "I Live Outside Nigeria" }
];

export const businessCategories = [
  {
    value: "fashion",
    label: "Fashion and Apparel",
    icon: <FashionIcon />,
  },
  {
    value: "electronics",
    label: "Electronics and Gadgets",
    icon: <ElectronicsIcon />,
  },
  {
    value: "beauty",
    label: "Beauty and Personal Care",
    icon: <BeautyIcon />,
  },
  {
    value: "home",
    label: "Home and Living",
    icon: <HomeIcon />,
  },
  {
    value: "food",
    label: "Food and Beverages",
    icon: <FoodIcon />,
  },
  {
    value: "health",
    label: "Health and Wellness",
    icon: <HealthIcon />,
  },
  {
    value: "professional_services",
    label: "Professional Services",
    icon: <Briefcase size={18} />,
  },
  {
    value: "education",
    label: "Education and Training",
    icon: <GraduationCap size={18} />,
  },
  {
    value: "automotive",
    label: "Automotive",
    icon: <Car size={18} />,
  },
  {
    value: "sports",
    label: "Sports and Fitness",
    icon: <Dumbbell size={18} />,
  },
  {
    value: "travel",
    label: "Travel and Tourism",
    icon: <Plane size={18} />,
  },
  {
    value: "financial_services",
    label: "Financial Services",
    icon: <Landmark size={18} />,
  },
  {
    value: "other",
    label: "Other",
    icon: <MoreHorizontal size={18} />,
  },
];

export const businessType = [
  { value: "Physical Retail", label: "Physical Retail" },
  { value: "E-commerce", label: "E-commerce" },
  { value: "Marketplace", label: "Marketplace" },
  { value: "Services Business", label: "Services Business" },
  { value: "Restaurants", label: "Restaurants" },
  { value: "Digital Product", label: "Digital Product" },
  { value: "Agency", label: "Agency" },
  { value: "Others", label: "Others" },
]






